module.exports = __webpack_public_path__ + "static/img/3bg_17.f83d86f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_17.png
// module id = 684
// module chunks = 1